import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import axios from 'axios';

import merge from 'deepmerge';

class HttpService {
  /**
   * Get params
   */
  public constructor(
    private readonly getConfig: () => AxiosRequestConfig,
    private readonly statusMap: Record<string, (response: AxiosResponse) => any>
  ) {}

  /**
   * Do api request
   */
  public request = async <T = any>(
    config: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> => {
    const defaults = this.getConfig();

    let response: AxiosResponse;
    let failure = false;

    const { data = {}, url } = config;

    try {
      const configuration = merge(defaults, {
        ...config,
        url,
        data
      });

      if (typeof window !== 'undefined') {
        if (data instanceof FormData) {
          configuration.data = data;
        }
      }

      response = await axios(configuration);
    } catch (error) {
      // @ts-expect-error ?????
      response = error.response;

      failure = true;
    }

    for (const status in this.statusMap) {
      if (response.status != Number(status)) continue;

      const handler = this.statusMap[status];
      const next = handler(response);

      if (next) break;
    }

    if (failure) {
      throw response;
    }

    return response as AxiosResponse<T>;
  };

  public testRequest = (defaults: AxiosRequestConfig) => {
    const instance = axios.create(defaults);

    return async (
      { headers = {}, ...config }: AxiosRequestConfig,
      enabled = true
    ) => {
      try {
        headers['Cache-Control'] = 'no-cache';
        const response = await instance({
          ...config,
          headers
        });

        return response;
      } catch (e) {
        const error = e as AxiosError;

        switch (true) {
          case enabled && error?.response?.status == 401: {

            break;
          }

          default: {
            throw error;
          }
        }
      }
    };
  };
}

export { HttpService };
